"use strict";

var __importDefault = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  },
  react_1 = (Object.defineProperty(exports, "__esModule", {
    value: !0
  }), exports.DotsNavigation = void 0, __importDefault(require("react"))),
  types_1 = require("../types"),
  utils_1 = require("../utils"),
  DotsNavigation = function (e) {
    var a = e.state,
      n = e.onClick,
      r = e.onMouseEnter,
      l = e.onMouseLeave,
      t = e.controlsStrategy,
      u = e.renderDotsItem,
      c = a.itemsCount,
      _ = a.itemsInSlide,
      d = a.infinite,
      e = a.autoWidth,
      m = a.activeIndex,
      v = (0, utils_1.getSlideItemInfo)(a).isNextSlideDisabled,
      f = (0, utils_1.hasDotForEachSlide)(e, t),
      D = (0, utils_1.getDotsNavigationLength)(c, _, f);
    return react_1.default.createElement("ul", {
      className: types_1.Classnames.DOTS
    }, Array.from({
      length: c
    }).map(function (e, t) {
      var i, s, o;
      if (t < D) return s = (0, utils_1.checkIsTheLastDotIndex)(t, Boolean(d), D), i = (0, utils_1.getItemIndexForDotNavigation)(t, s, c, _), s = (0, utils_1.getActiveSlideIndex)(v, a), f && ((s = m) < 0 ? s = c - 1 : c <= m && (s = 0), i = t), s = s === t ? types_1.Modifiers.ACTIVE : "", o = u ? types_1.Modifiers.CUSTOM : "", o = (0, utils_1.concatClassnames)(types_1.Classnames.DOTS_ITEM, s, o), react_1.default.createElement("li", {
        key: "dot-item-".concat(t),
        onMouseEnter: r,
        onMouseLeave: l,
        onClick: function () {
          return n(i);
        },
        className: o
      }, u && u({
        isActive: Boolean(s),
        activeIndex: t
      }));
    }));
  };
exports.DotsNavigation = DotsNavigation;